document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const html = document.documentElement;
    const overlay = document.getElementById('overlay');
    const popups = document.querySelectorAll('.ac-popup-review');

    const updateBodyScroll = () => {
        const isPopupOpen = [...popups].some(p => p.classList.contains('is-visible'));
        body.style.overflow = isPopupOpen ? 'hidden' : '';
        html.style.overflow = isPopupOpen ? 'hidden' : '';
    };

    const togglePopup = (popupId) => {
        const popup = document.getElementById(popupId);
        if (!popup) return;

        const isVisible = popup.classList.contains('is-visible');
        popup.classList.toggle('is-visible', !isVisible);
        overlay.classList.toggle('is-visible', !isVisible);
        updateBodyScroll();
    };

    document.querySelectorAll('[data-popup-id]').forEach(el =>
        el.addEventListener('click', (e) => {
            e.preventDefault();
            togglePopup(el.getAttribute('data-popup-id'));
        })
    );

    overlay?.addEventListener('click', () => {
        popups.forEach(popup => popup.classList.remove('is-visible'));
        overlay.classList.remove('is-visible');
        updateBodyScroll();
    });

    document.querySelectorAll('.close-popup').forEach(btn =>
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const popup = btn.closest('.ac-popup-review');
            if (popup) popup.classList.remove('is-visible');
            overlay.classList.remove('is-visible');
            updateBodyScroll();
        })
    );

    document.querySelectorAll('[data-show-more-desc]').forEach(button => {
        button?.addEventListener('click', () => {
            const text = button.previousElementSibling;
            const showMore = button.dataset.showMore;
            const showLess = button.dataset.showLess;
            text.classList.toggle('expanded');

            button.textContent = text.classList.contains('expanded') ? showLess : showMore;
        });
    });

});
